module.exports = __webpack_public_path__ + "img/Imgur.634d513f.png";